import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  key: 0,
  style: {"color":"#6b7280","font-size":"14px"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "module-group" }
const _hoisted_5 = { class: "module-group-title" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "module-cards" }
const _hoisted_8 = { class: "module-card-top" }
const _hoisted_9 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_10 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_11 = {
  key: 2,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_12 = {
  key: 3,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_13 = {
  key: 4,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_14 = {
  key: 5,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}
const _hoisted_15 = { class: "module-toggle" }
const _hoisted_16 = ["onUpdate:modelValue", "id"]
const _hoisted_17 = { class: "module-card-label" }
const _hoisted_18 = { class: "module-card-status" }
const _hoisted_19 = {
  class: "module-group module-group--ia",
  style: {"margin-top":"24px"}
}
const _hoisted_20 = { class: "flags-list" }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = { class: "flag-label" }
const _hoisted_23 = {
  key: 0,
  class: "ia-group-warn"
}
const _hoisted_24 = {
  class: "module-group",
  style: {"margin-top":"24px"}
}
const _hoisted_25 = { class: "flags-list" }
const _hoisted_26 = {
  key: 0,
  class: "flag-row"
}
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = { class: "flag-label" }
const _hoisted_29 = {
  key: 2,
  class: "data-error",
  style: {"margin-top":"16px"}
}
const _hoisted_30 = {
  key: 3,
  class: "data-success",
  style: {"margin-top":"16px"}
}
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "data-title" }, "Módulos", -1)),
    _cache[13] || (_cache[13] = _createElementVNode("p", { style: {"font-size":"13px","color":"#6b7280","margin":"0 0 20px"} }, "Habilite ou desabilite modos e funcionalidades para esta obra. Módulos desabilitados ficam ocultos para todos os usuários.", -1)),
    ($setup.flagsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Carregando..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createStaticVNode("<svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"3\" width=\"7\" height=\"7\"></rect><rect x=\"14\" y=\"14\" width=\"7\" height=\"7\"></rect><rect x=\"3\" y=\"14\" width=\"7\" height=\"7\"></rect></svg> Modos de operação ", 2)),
              _createElementVNode("button", {
                class: "flags-save-inline",
                type: "button",
                disabled: $setup.flagsSaving,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.saveFlags && $setup.saveFlags(...args)))
              }, _toDisplayString($setup.flagsSaving ? 'Salvando...' : 'Salvar'), 9, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.featureFlags, (flag) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: flag.key
                }, [
                  (['construction','maintenance','warehouse','office','portaria','ia'].includes(flag.key))
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: _normalizeClass(["module-card", { 'module-card--on': flag.enabled, [`module-card--${flag.key}`]: true }])
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          (flag.key === 'construction')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" }, null, -1),
                                _createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" }, null, -1)
                              ]))]))
                            : (flag.key === 'maintenance')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[4] || (_cache[4] = [
                                  _createElementVNode("path", { d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" }, null, -1)
                                ]))]))
                              : (flag.key === 'warehouse')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[5] || (_cache[5] = [
                                    _createElementVNode("path", { d: "M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" }, null, -1)
                                  ]))]))
                                : (flag.key === 'office')
                                  ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[6] || (_cache[6] = [
                                      _createElementVNode("rect", {
                                        x: "2",
                                        y: "7",
                                        width: "20",
                                        height: "14",
                                        rx: "2"
                                      }, null, -1),
                                      _createElementVNode("path", { d: "M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" }, null, -1)
                                    ]))]))
                                  : (flag.key === 'portaria')
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_13, [...(_cache[7] || (_cache[7] = [
                                        _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" }, null, -1),
                                        _createElementVNode("path", { d: "M9 22V12h6v10" }, null, -1)
                                      ]))]))
                                    : (flag.key === 'ia')
                                      ? (_openBlock(), _createElementBlock("svg", _hoisted_14, [...(_cache[8] || (_cache[8] = [
                                          _createElementVNode("path", { d: "M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z" }, null, -1),
                                          _createElementVNode("path", {
                                            d: "M19 14l.75 2.25L22 17l-2.25.75L19 20l-.75-2.25L16 17l2.25-.75L19 14z",
                                            opacity: ".5"
                                          }, null, -1)
                                        ]))]))
                                      : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => ((flag.enabled) = $event),
                              id: `flag-${flag.key}`
                            }, null, 8, _hoisted_16), [
                              [_vModelCheckbox, flag.enabled]
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "module-toggle-track" }, null, -1))
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(flag.label), 1),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(flag.enabled ? 'Ativo' : 'Desabilitado'), 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"module-group-title module-group-title--ia\"><svg width=\"13\" height=\"13\" viewBox=\"0 0 24 24\" fill=\"currentColor\"><path d=\"M12 2l1.5 4.5L18 8l-4.5 1.5L12 14l-1.5-4.5L6 8l4.5-1.5L12 2z\"></path><path d=\"M19 14l.75 2.25L22 17l-2.25.75L19 20l-.75-2.25L16 17l2.25-.75L19 14z\" opacity=\".5\"></path></svg> Recursos de IA </div><p class=\"ia-group-hint\"> O card &quot;Modo IA&quot; acima é o interruptor geral. Os recursos abaixo controlam cada uso de IA individualmente — um recurso só funciona se o Modo IA E o recurso estiverem ativos. </p>", 2)),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.featureFlags, (flag) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: flag.key
                }, [
                  (flag.group === 'ia')
                    ? (_openBlock(), _createElementBlock("label", {
                        key: 0,
                        class: _normalizeClass(["flag-row flag-row--ia", { 'flag-row--dimmed': !$setup.iaModeEnabled }])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((flag.enabled) = $event)
                        }, null, 8, _hoisted_21), [
                          [_vModelCheckbox, flag.enabled]
                        ]),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(flag.label), 1)
                      ], 2))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            (!$setup.iaModeEnabled)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Modo IA desabilitado — nenhum recurso de IA funciona nesta obra, independente dos toggles acima."))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "module-group-title" }, [
              _createElementVNode("svg", {
                width: "13",
                height: "13",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("polyline", { points: "22 12 18 12 15 21 9 3 6 12 2 12" })
              ]),
              _createTextVNode(" Funcionalidades ")
            ], -1)),
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.featureFlags, (flag) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: flag.key
                }, [
                  (!['construction','maintenance','warehouse','office','ia'].includes(flag.key) && flag.group !== 'ia')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((flag.enabled) = $event)
                        }, null, 8, _hoisted_27), [
                          [_vModelCheckbox, flag.enabled]
                        ]),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(flag.label), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ])),
    ($setup.flagsError)
      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString($setup.flagsError), 1))
      : _createCommentVNode("", true),
    ($setup.flagsSuccess)
      ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString($setup.flagsSuccess), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "btn-admin-primary",
      style: {"margin-top":"20px"},
      type: "button",
      disabled: $setup.flagsSaving,
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.saveFlags && $setup.saveFlags(...args)))
    }, _toDisplayString($setup.flagsSaving ? 'Salvando...' : 'Salvar módulos'), 9, _hoisted_31)
  ]))
}